import React from 'react'
import campfireImage from '../assets/campfire2.png'

const Faqs = () => {
  return (
    <div className='w-full'>
        <div className='max-w-[1240px] mx-auto'>
      <section class="text-gray-700">
        <div class="container px-12 md:px-5 mx-auto">
          <div class="mb-5 grid grid-cols-1 md:grid-cols-2 mt-32">
            <div>
            <h1 class="sm:text-3xl text-3xl font-medium title-font text-gray-900 mb-4">
              Frequently Asked Question
            </h1>
            <p class="text-xl">
              We know you are excited and have many questions, so we prepared some common facts for you!
            </p>
            <div class="flex flex-wrap">
              <div class="w-full lg:w-full px-4 py-2">
                  <details class="mb-4">
                  <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4  hover:bg-sky-200">
                    What is EtherFrens?
                  </summary>

                  <span>
                    EtherFrens is a project that aims to connect others through story telling and art. It is a profile picture-based NFT art collection that is heavily inspired by pop culture, anime and asian cultural influences. 
                  </span>
                </details>
                <details class="mb-4">
                  <summary class="font-semibold bg-gray-200 rounded-md py-2 px-4 hover:bg-sky-200">
                    What intellectual property rights do holders receive?
                  </summary>

                  <span>
                    We value your rights. In the spirit of defi and ownership, holders will receive complete commercial art rights to the Fren that they own. <i>(More info soon)</i>. 
                  </span>
                </details>
                <details class="mb-4">
                  <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4 hover:bg-sky-200">
                    How big is the collection?
                  </summary>

                  <span>
                  At this time the collection size has yet to been determined. While this will be revisted later, we do value quality over quantity.
                  </span>
                </details>
                <details class="mb-4">
                  <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4 hover:bg-sky-200">
                    How do I get one?
                  </summary>
                  <p>Slots are given out through the following options:</p> 
                  <ul>
                    <li pl-5> 
                    1. Randomly selected through giveaway or raffles on <a href="https://www.twitter.com/EtherFrens">Twitter</a>. We encourage you to follow for latest raffle and giveaway updates.
                    <br/>
                    2. Apply to our Frensly (FrensOnly) Application (Coming soon)
                    </li>
                  </ul>
                  <p>
                    
                  </p>
                </details>
                <details class="mb-4">
                  <summary class="font-semibold bg-gray-200 rounded-md py-2 px-4 hover:bg-sky-200">
                    Which Network?
                  </summary>

                  <div>
                    EtherFrens is deployed on the Ethereum blockchain. The genesis NFT contract "EtherFrens" is ERC-721A compliant and deployed to the following <a href="https://etherscan.io/address/0xadae33873744909d231e627eee918b261abf35f4">contract address</a>.
                  </div>
                </details>
              </div>
            </div>
            </div>
            <div>
              <img className="w-[600px] p-5" src={campfireImage} alt="" />
            </div>
          </div>
        </div>
      </section>
      </div>
      </div>
  )
}

export default Faqs